/* eslint-disable no-param-reassign */
var cleanObject = function (obj) {
    Object.keys(obj).forEach(function (key) { return obj[key] === undefined && delete obj[key]; });
    return obj;
};
export default cleanObject;
